








































import { defineComponent, computed, ref, PropType } from '@nuxtjs/composition-api'

import IconFa6SolidAngleLeft from '~icons/fa6-solid/angle-left'
import IconFa6SolidAngleRight from '~icons/fa6-solid/angle-right'

import CitationCarouselCard from './CitationCarouselCard.vue'
import { useMobile } from '~/composables/ui/useMobile'
import { CitationImagesUrls } from '~/types/product/productTypes'

export default defineComponent({
  components: {
    CitationCarouselCard,
    IconFa6SolidAngleLeft,
    IconFa6SolidAngleRight,
  },
  props: {
    citationsImages: {
      type: Array as PropType<CitationImagesUrls[]>,
      required: false,
      default: () => [],
    },
    currentImage: {
      type: Number,
      required: true,
    },
  },
  emits: ['beforeChange'],
  setup(props, { emit }) {
    const slickOptions = {
      arrows: false,
      slidesToShow: 3,
      lazyLoad: 'ondemand',
      infinite: false,
      responsive: [
        {
          breakpoint: 399,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    }

    const { isMobile, isTablet } = useMobile()

    const backDisabled = computed(() => props.currentImage <= 1)
    const futureDisabled = computed(
      () => props.currentImage + (isMobile.value ? 1 : isTablet.value ? 2 : 3) > props.citationsImages.length
    )

    const isMultipleImages = computed(() => {
      return props.citationsImages.length > 3
    })

    const onAfterChange = (_: number, newSlideIndex: number) => {
      emit('beforeChange', newSlideIndex + 1)
    }

    const citationImagesCarousel = ref()
    const onArrowClick = (whereTo: string) => {
      if (whereTo === 'next') {
        citationImagesCarousel.value.next()
      } else {
        citationImagesCarousel.value.prev()
      }
    }

    return {
      onArrowClick,
      slickOptions,
      onAfterChange,
      isMultipleImages,
      citationImagesCarousel,
      backDisabled,
      futureDisabled,
    }
  },
})
